<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="订单号" prop="orderNo" >
        <a-input v-model="form.orderNo" placeholder="请输入订单号" />
      </a-form-model-item>
      <a-form-model-item label="支付单号" prop="payNo" >
        <a-input v-model="form.payNo" placeholder="请输入支付单号" />
      </a-form-model-item>
      <a-form-model-item label="三方订单号" prop="outTrandNo" >
        <a-input v-model="form.outTrandNo" placeholder="请输入三方订单号" />
      </a-form-model-item>
      <a-form-model-item label="充值金币数" prop="rechargeDiamond" >
        <a-input v-model="form.rechargeDiamond" placeholder="请输入充值金币数" />
      </a-form-model-item>
      <a-form-model-item label="支付金额" prop="payMoney" >
        <a-input v-model="form.payMoney" placeholder="请输入支付金额" />
      </a-form-model-item>
      <a-form-model-item label="价格菜单id" prop="menuId" >
        <a-input v-model="form.menuId" placeholder="请输入价格菜单id" />
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" >
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="状态 0-待支付  1-支付成功 2-支付失败" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrder, addOrder, updateOrder } from '@/api/recharge/order'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        orderNo: null,

        payNo: null,

        outTrandNo: null,

        rechargeDiamond: null,

        payMoney: null,

        menuId: null,

        payTime: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id不能为空' }
        ],
        orderNo: [
          { required: true, message: '订单号不能为空' }
        ],
        payMoney: [
          { required: true, message: '支付金额不能为空' }
        ],
        status: [
          { required: true, message: '状态 0-待支付  1-支付成功 2-支付失败不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        orderNo: null,
        payNo: null,
        outTrandNo: null,
        rechargeDiamond: null,
        payMoney: null,
        menuId: null,
        payTime: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrder(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrder(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
